import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StorageUrlPipe } from './storage-url.pipe';
import { StorageUrlUnsanitizedPipe } from './storage-url-unsanitized.pipe';

const PIPES = [
  StorageUrlPipe,
  StorageUrlUnsanitizedPipe
]

@NgModule({
  declarations: PIPES,
  imports: [
    CommonModule
  ],
  providers: PIPES,
  exports: PIPES
})
export class MyPipeModule { }
